
export const FlattenObject = (data: any | object) => {
    let result: Array<string> = Object.keys(data).reduce(function (r, k) {
        return r.concat(data[k]);
    }, []);

    return result;
};

export default FlattenObject;